<div class="main-body">
    @if (showHeaderIcon) {
        <ap-header icon="logo-ideal" layout="small" class="ap-margin-bottom-6 ap-display-block"></ap-header>
    } @else {
        <ap-header layout="small" class="ap-margin-bottom-6 ap-display-block"></ap-header>
    }

    <div class="canvas-small">
        <div class="ap-margin-bottom-2 ap-display-block">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
<ideal-footer></ideal-footer>
